function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#E43D30;stroke:#1D1D1D;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:#E0DBD5;stroke:#1D1D1D;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:#18988B;stroke:#222222;stroke-width:2;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#1D1D1D;stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 78.36,
  cy: 81.2,
  r: 13.82
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 78.36,
  cy: 81.2,
  r: 6.84
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 22.8,
  cy: 81.2,
  r: 13.82
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 22.8,
  cy: 81.2,
  r: 6.84
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M87.68,30.01H61.25c-1.54,0-2.79,1.26-2.79,2.79v2.04c0,1.54,1.26,2.79,2.79,2.79h26.44 c1.54,0,2.79-1.26,2.79-2.79v-2.04C90.48,31.27,89.22,30.01,87.68,30.01z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M25.35,9.27h4.45h9.92c1.86,0,3.39,1.52,3.39,3.39v0c0,1.86-1.52,3.39-3.39,3.39h-9.92v37.43h31.81 c1.02,0,1.86-0.84,1.86-1.86V37.64H83.1c6.65,0,12.09,5.44,12.09,12.09v16.55c0,6.65-5.44,12.09-12.09,12.09 c0,0-56.5-0.01-56.55-0.01h-4.59V58.34c0,0,0-0.01,0-0.01v-0.66c0,0,0,0,0,0V12.66v0C21.97,10.79,23.49,9.27,25.35,9.27z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M74.29,58.84l20.91,0.01v19.39H58.91c-0.27-1.16-0.42-2.36-0.42-3.6C58.48,65.95,65.59,58.84,74.29,58.84z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 91.22,
  y1: 49.27,
  x2: 88.82,
  y2: 45.76
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 79.74,
  y1: 51.1,
  x2: 81.37,
  y2: 47.17
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 26.2,
  y1: 51.1,
  x2: 27.83,
  y2: 47.17
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 44.97,
  y1: 63.89,
  x2: 46.6,
  y2: 59.96
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 63.43,
  y1: 48.11,
  x2: 67.12,
  y2: 46
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 21.99,
  y1: 58.54,
  x2: 25.68,
  y2: 56.43
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 77.37,
  y1: 42.7,
  x2: 73.58,
  y2: 40.79
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 36.52,
  y1: 14.26,
  x2: 33.99,
  y2: 10.85
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 27.45,
  y1: 19.5,
  x2: 23.65,
  y2: 17.58
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 27.39,
  y1: 38.47,
  x2: 23.43,
  y2: 40.01
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 25.92,
  y1: 31.44,
  x2: 22.12,
  y2: 29.52
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 83.51,
  y1: 40.5,
  x2: 87.22,
  y2: 38.42
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 25.63,
  y1: 27.59,
  x2: 29.34,
  y2: 25.51
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 61.38,
  y1: 58.49,
  x2: 65.09,
  y2: 56.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 25.3,
  y1: 13.95,
  x2: 29.01,
  y2: 11.87
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 38.02,
  y1: 58.49,
  x2: 41.73,
  y2: 56.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 80.79,
  y1: 59.29,
  x2: 77.78,
  y2: 56.29
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 69.06,
  y1: 50.97,
  x2: 71.5,
  y2: 54.45
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 54.24,
  y1: 65.12,
  x2: 50.86,
  y2: 67.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 55.64,
  y1: 74.55,
  x2: 51.68,
  y2: 73.01
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 45.75,
  y1: 72.21,
  x2: 43.22,
  y2: 75.63
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 58.59,
  y1: 61.44,
  x2: 61.03,
  y2: 64.92
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 38.85,
  y1: 65.05,
  x2: 41.28,
  y2: 68.54
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 55.43,
  y1: 57.83,
  x2: 51.26,
  y2: 56.99
}), /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 90.9,
  y1: 55.29,
  x2: 86.83,
  y2: 54.06
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M6.89,78.44c-0.01-0.78-0.03-3.02-0.03-3.69c0-8.66,7.07-15.75,15.72-15.8v0c0.01,0,0.02,0,0.02,0 c0.01,0,0.02,0,0.02,0v0c8.65,0.05,15.72,7.14,15.72,15.8c0,0.67-0.01,2.91-0.02,3.69H6.89z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 49.98,
  y: 13.98,
  transform: "matrix(-1 -4.492951e-11 4.492951e-11 -1 149.3587 35.9325)",
  className: "st1",
  width: 49.39,
  height: 7.98
}), /*#__PURE__*/React.createElement("rect", {
  x: 49.98,
  y: 6,
  transform: "matrix(-1 -4.489266e-11 4.489266e-11 -1 149.3587 19.9789)",
  className: "st1",
  width: 49.39,
  height: 7.98
}), /*#__PURE__*/React.createElement("rect", {
  x: 49.98,
  y: 21.93,
  transform: "matrix(-1 -4.492951e-11 4.492951e-11 -1 149.3587 51.8486)",
  className: "st1",
  width: 49.39,
  height: 7.98
}), /*#__PURE__*/React.createElement("rect", {
  x: 72.25,
  y: 6.11,
  transform: "matrix(-1 -4.490909e-11 4.490909e-11 -1 149.9467 35.9542)",
  className: "st0",
  width: 5.45,
  height: 23.73
}));

function SvgMoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107 101",
    style: {
      enableBackground: "new 0 0 107 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoto);
export default __webpack_public_path__ + "static/media/moto.12db0a69.svg";
export { ForwardRef as ReactComponent };